var _polygon;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTriangle = function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "9.77 13.65 4.17 3.38 1.94 7.17 0.2 7.17 4.23 0.35 9.83 10.62 12.06 6.83 13.8 6.83 9.77 13.65"
  })));
};

export default SvgTriangle;